const cmsPagesConstantsAr = {
  cmsPagesTitle: 'الصفحات ',
  cmsPagesBreadcrumbs: 'الصفحات',
  cmsPagesTermsAndConditions: 'الشروط والأحكام',
  cmsPagesTermsAndConditionsBreadcrumb: 'الشروط والأحكام',
  cmsPagesPrivacyPolicy: 'سياسة الخصوصية و سياسة ملفات تعريف الإرتباط',
  cmsPagesPrivacyPolicyBreadcrumb: 'سياسة الخصوصية',
  cmsPagesCookiesPolicy: 'سياسة ملفات تعريف الارتباط',
  cmsPagesCookiesPolicyBreadcrumb: 'سياسة ملفات تعريف الارتباط',
  cmsPagesFaq: 'الأسئلة الشائعة',
  cmsPagesFaqsBreadcrumb: 'الأسئلة الشائعة',
  cmsPagesSuccessStories: 'قصص النجاح',
  cmsPagesSuccessStoriesBreadcrumb: 'قصص النجاح',
  cmsPagesBlogs: 'المدونات',
  cmsPagesBlogsBreadcrumb: 'المدونات',
  cmsPagesAboutUs: 'من نحن',
  cmsPagesAboutUsBreadcrumb: 'من نحن',
  cmsPricingTermsAndConditions: 'الشروط والأحكام',
  cmsCheckoutTermsAndConditions: 'شروط وأحكام عملية الشراء',
};

export default cmsPagesConstantsAr;
